/**
 * This code was generated by Builder.io.
 */
import React, { useState } from "react";
import styles from "./PremiumReportList.module.css";
import CreditUnionInfo from "./CreditUnionInfo";
import TabSection from "./TabSection";
import CreditUnionSearch from "../CreditUnionSearch/CreditUnionSearch";
import Table from "../TableComponents/Table";
import PremiumSelection from "../PremiumSelection/PremiumSelection";


interface PremiumReportListProps {
  userName: string;
  creditUnionNumber: string;
}

const PremiumReportList: React.FC<PremiumReportListProps> = ({
  userName,
  creditUnionNumber,
}) => {
  const [activeTab, setActiveTab] = useState<string>("premium adjustment");

  const handleTabClick = (tabName: string) => {
    setActiveTab(tabName);
    };

  return (
    <div className={styles.premiumReportList}>
      <CreditUnionSearch />
      <CreditUnionInfo creditUnionNumber={creditUnionNumber} />
      <TabSection activeTab={activeTab} onTabClick={handleTabClick} />
      {activeTab === 'Create New' && <div><PremiumSelection/></div>}
      {activeTab === 'premium adjustment' && <div> <Table /></div>}  
     
    </div>
  );
};

export default PremiumReportList;
